export default __webpack_public_path__ + "static/media/square-icon.fb57d650.svg";